import { render } from "./SwitchForm.vue?vue&type=template&id=2e180b33"
import script from "./SwitchForm.vue?vue&type=script&lang=js"
export * from "./SwitchForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__